import axios from "axios";

const apiPublic = axios.create({
  baseURL: process.env.VUE_APP_API,
  headers: {
    "Content-Type": "application/json",
    "X-Api-Key": process.env.VUE_APP_API_KEY,
  },
});

export const getOperadoresPublic = async () => {
  const response = await apiPublic.get('public/operadores/');
  return response.data;
};

export const getProductosPublic = async () => {
  const response = await apiPublic.get('public/catalogo-productos/');
  return response.data;
};

export const getPigmentosPublic = async () => {
  const response = await apiPublic.get('public/colores/');
  return response.data;
};

export const getCodigosDefectoPublic = async () => {
  const response = await apiPublic.get('public/codigos-defecto/');
  return response.data;
};


// ── Envío del formulario ────────────────────────────────────────────────────

/**
 * Envía el formulario de Consumo de Materia Prima al back.
 * Recibe el payload ya construido por buildPayload() del composable.
 *
 * Payload esperado:
 * {
 *   tipo_reporte:   "materia_prima",
 *   fecha_registro: "2026-06-25T21:58:35.410Z",
 *   fecha:          "2026-06-25",
 *   hora:           "16:00",
 *   id_operador:    2,
 *   id_maquina:     1,
 *   id_producto:    9,
 *   id_color:       3,
 *   cantidad_pigmento: 100,
 *   aditivo:        true,
 *   tpu_items: [{ numero: 1, tpu_id: 2, cantidad: 10, unidad: "kg" }],
 *   molida:    { cantidad: 10, unidad: "kg" },
 *   comentarios: ""
 * }
 *
 * @param {object} payload — resultado de buildPayload()
 * @returns {object} — registro creado (ScrapAlmacenLaserDetalleSerializer)
 */
export const CrearScrapAlmacenLaser = async (payload) => {
  const response = await apiPublic.post(
    "formularios/scrap-almacen-laser/",
    payload
  );
  return response.data;
};

/**
 * Descarga el Excel de Scrap de Almacen y Laser en el rango de fechas dado.
 * Requiere fecha_inicio y fecha_fin en formato YYYY-MM-DD.
 * Usa la instancia autenticada (JWT) porque es un endpoint del admin.
 *
 * @param {string} fechaInicio — YYYY-MM-DD
 * @param {string} fechaFin    — YYYY-MM-DD
 */
export const exportarScrapAlmacenLaser = async (fechaInicio, fechaFin) => {
  const { api } = await import("./api_backend");
 
  const response = await api.get("exportar/scrap-almacen-laser/", {
    params: { fecha_inicio: fechaInicio, fecha_fin: fechaFin },
    responseType: "blob",
  });
 
  const url  = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement("a");
  link.href  = url;
  link.setAttribute("download", `scrap_almacen_${fechaInicio}_a_${fechaFin}.xlsx`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

/**
 * Resumen completo del dashboard de Scrap Almacén y Láser:
 * productos con cantidad de scrap, total, y % respecto al plan real.
 *
 * @param {object} params - { semana_inicio, semana_fin, anio?, productos? }
 * @returns {{ productos, total_scrap, total_real, porcentaje_scrap }}
 */
export const getScrapAlmacenResumen = async (params) => {
  const { api } = await import("./api_backend");
  const response = await api.get("analitica/scrap-almacen/resumen/", { params });
  return response.data;
};
 
/**
 * Datos para el gráfico de Pareto de defectos (Periodo A).
 * @param {object} params - { semana_inicio, semana_fin, anio?, productos?, defectos? }
 * @returns [{codigo, descripcion, cantidad_scrap, porcentaje, porcentaje_acumulado}]
 */
export const getScrapAlmacenDefectosPareto = async (params) => {
  const { api } = await import("./api_backend");
  const response = await api.get("analitica/scrap-almacen/defectos-pareto/", { params });
  return response.data;
};